import script from "./OurLossesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OurLossesPage.vue?vue&type=script&setup=true&lang=js"

import "./OurLossesPage.vue?vue&type=style&index=0&id=d07c08b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d07c08b4"]])

export default __exports__